import styles from "./index.module.scss";
import MaterialMetaData from "../MaterialMetaData";
import DefaultTemplatePanel from "../../../layout/content-templates/default/DefaultTemplatePanel";
import AssetCover from "common/features/asset/AssetCover";
import ProgramDetails from "./ProgramDetails";
import { Action } from "../useMaterialActions";
import { MaterialAction } from "../MaterialActions";
import { CourseMaterial } from "../coursesLoader";
import { getImageSource } from "../materialUtils.ts";
import OrderInfoBanner from "./OrderInfoBanner.tsx";
import { usePreferredShippingAddress } from "../usePreferredShippingAddress.tsx";

interface MaterialPanelProps {
  setOpenPanelInfo: () => void;
  actions: Action[];
  courseMaterial: CourseMaterial;
}
type MaterialContentProps = Omit<MaterialPanelProps, "setOpenPanelInfo">;

export const MaterialPanelContents = (props: MaterialContentProps) => {
  const { actions, courseMaterial } = props;
  const { vbid } = courseMaterial;
  const accessActions = actions.filter(
    (action: Action) =>
      action.category === "access" && action.type !== "view_shipping"
  );
  const { preferredShippingAddress } = usePreferredShippingAddress();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.coverRow}>
          <div className={styles.cover}>
            <AssetCover
              vbid={vbid}
              width={120}
              width2x={240}
              source={getImageSource(courseMaterial)}
            />
          </div>
          <div className={styles.metaData}>
            <MaterialMetaData
              courseMaterial={courseMaterial}
              showAccessDuration={false}
              titleTag="h2"
            >
              <div className={styles.actions}>
                {accessActions.map((action) => (
                  <div key={action.label}>
                    <MaterialAction className={styles.action} action={action} />
                  </div>
                ))}
              </div>
            </MaterialMetaData>
          </div>
        </div>
      </div>
      <div className={styles.bottomArea}>
        <OrderInfoBanner
          courseMaterial={courseMaterial}
          preferredAddress={preferredShippingAddress}
        />
        <ProgramDetails courseMaterial={courseMaterial} actions={actions} />
      </div>
    </>
  );
};

export default function MaterialPanel(props: MaterialPanelProps) {
  const { setOpenPanelInfo, actions, courseMaterial } = props;

  return (
    <DefaultTemplatePanel onRequestClose={() => setOpenPanelInfo()}>
      <MaterialPanelContents
        actions={actions}
        courseMaterial={courseMaterial}
      />
    </DefaultTemplatePanel>
  );
}
